export enum ESvgIcon {
  SCROLL_LEFT = 'scrollLeft',
  SCROLL_RIGHT = 'scrollRight',
  RIGHT_ARROW = 'rightArrow'
}
